// extracted by css-extract-rspack-plugin
export default {"label":"r_6yREErpVgVW8g6","small":"HPkqSxxNuiIsHmgF","medium":"ndk5qL6vkWEi4FZG","truncate":"kZ5_l1b8IlAinfMc"};